import { ColorCombinationEnum, CombinatedColorsEnum } from '../types';

export const TRACKING_ID_4 = 'G-09T5VRHRJK';
export const TRACKING_ID = 'UA-28323291-23';
export const HOTJAR_ID = 2689834;

export const ColorCombinationOptions = {
  [ColorCombinationEnum.COMPLEMENTARY]: {
    iconName: 'complementary-gen',
    value: ColorCombinationEnum.COMPLEMENTARY,
    label: 'Complementary',
    combinatedColors: [CombinatedColorsEnum.MAIN_COLOR, CombinatedColorsEnum.FIRST_COLOR],
    corners: [0, 180],
  },
  [ColorCombinationEnum.MONOCHROMATIC]: {
    iconName: 'monochromatic-gen',
    value: ColorCombinationEnum.MONOCHROMATIC,
    label: 'Monochromatic',
    combinatedColors: [CombinatedColorsEnum.MAIN_COLOR, CombinatedColorsEnum.FIRST_COLOR],
    corners: [0, 0],
  },
  [ColorCombinationEnum.ANALOGOUS]: {
    iconName: 'analogous-gen',
    value: ColorCombinationEnum.ANALOGOUS,
    label: 'Analogous',
    combinatedColors: [
      CombinatedColorsEnum.MAIN_COLOR,
      CombinatedColorsEnum.FIRST_COLOR,
      CombinatedColorsEnum.SECOND_COLOR,
    ],
    corners: [0, 30, -30],
  },
  [ColorCombinationEnum.TRIADIC]: {
    iconName: 'triadic-gen',
    value: ColorCombinationEnum.TRIADIC,
    label: 'Triadic',
    combinatedColors: [
      CombinatedColorsEnum.MAIN_COLOR,
      CombinatedColorsEnum.FIRST_COLOR,
      CombinatedColorsEnum.SECOND_COLOR,
    ],
    corners: [0, 120, -120],
  },
  [ColorCombinationEnum.TETRADIC]: {
    iconName: 'tetradic-gen',
    value: ColorCombinationEnum.TETRADIC,
    label: 'Tetradic',
    combinatedColors: [
      CombinatedColorsEnum.MAIN_COLOR,
      CombinatedColorsEnum.FIRST_COLOR,
      CombinatedColorsEnum.SECOND_COLOR,
      CombinatedColorsEnum.THIRD_COLOR,
    ],
    corners: [0, 90, -90, 180],
  },
};
